import axios from "axios";
const token = window.localStorage.getItem("token");
const config = {
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        Authorization: `${token}`
    }
};
// const baseURL = process.env.REACT_APP_API_URL;
import secureLocalStorage from "react-secure-storage";
const baseURL = secureLocalStorage.getItem("baseURL");
export const get_all_lead_pipelines = async () => {
    let response = await axios.get(baseURL + "/api/lead-pipeline", config);
    return response.data.data;
}
export const update_lead_pipeline = async (lead_pipeline_id, name, order) => {
    let response = await axios.patch(baseURL + "/api/lead-pipeline/" + lead_pipeline_id, {
        "name": name,
        "order": order,
    }, config);
    return response.data.data;
}
export const delete_lead_pipeline = async (lead_pipeline_id) => {
    let response = await axios.delete(baseURL + "/api/lead-pipeline/" + lead_pipeline_id, config);
    return response.data.data;
}